<template>
  <div class="products-page content-list-page">
    <div class="products-hero">
      <div>
        <p class="hero-kicker mb-1">مدیریت محتوا</p>
        <h1 class="mb-0">{{ isPost ? 'پست‌ها' : 'برگه‌ها' }}</h1>
      </div>
      <div class="hero-side">
        <div class="hero-count" v-if="paginationMeta && paginationMeta.total != null">
          <strong>{{ formatNumber(paginationMeta.total) }}</strong>
          <span>{{ isPost ? 'پست' : 'برگه' }}</span>
        </div>
        <div class="hero-badge">
          <b-icon :icon="isPost ? 'newspaper' : 'file-earmark-text'"></b-icon>
        </div>
      </div>
    </div>

    <div class="products-toolbar">
      <div class="products-toolbar-actions">
        <router-link class="products-tool-btn" :to="{ name: 'CreateContent' }">
          <b-icon icon="plus-lg"></b-icon>
          <span>{{ isPost ? 'ساخت پست جدید' : 'ساخت برگه جدید' }}</span>
        </router-link>
        <router-link class="products-tool-btn" :to="{ name: 'TrashContents', params: { type: isPost ? 'posts' : 'pages' } }">
          <b-icon icon="trash"></b-icon>
          <span>سطل زباله</span>
        </router-link>
        <LanguageSelectBox class="products-lang" @changeLanguage="getItems" module-name="content"/>
      </div>

      <div class="products-filter-bar">
        <div class="products-filter-row">
          <label class="products-filter-field content-search-field">
            <span><b-icon icon="search"></b-icon> جستجو</span>
            <input
                class="products-filter-input"
                v-model="searchWords"
                @keypress.enter.prevent="triggerSearch"
                :placeholder="isPost ? 'عنوان پست...' : 'عنوان برگه...'"
            >
          </label>
          <button type="button" class="products-more-btn content-search-btn" @click="triggerSearch">
            <b-icon icon="search"></b-icon>
            <span>جستجو</span>
          </button>
          <button v-if="activeSearch" type="button" class="products-more-btn" @click="clearSearch">
            <b-icon icon="x-lg"></b-icon>
            <span>پاک کردن</span>
          </button>
        </div>
      </div>
    </div>

    <div class="products-list-panel">
      <table-items :items="items" :loading="listLoading" :restoreState="false" :content-type="contentType"/>
      <div class="products-pager" v-if="!listLoading && items && items.length">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import tableItems from "./tableItems.vue";
import Pagination from "../Pagination.vue";
import LanguageSelectBox from "../Language/LanguageSelectBox";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import "../product/products-ui.css";

export default {
  name: "ContentListPage",
  components: {tableItems, Pagination, LanguageSelectBox},
  props: {
    contentType: {
      type: String,
      required: true,
      validator: (value) => ['page', 'post'].indexOf(value) !== -1
    }
  },
  data() {
    return {
      listLoading: true,
      awaitingData: false,
      loadingTimer: null,
      searchWords: '',
      activeSearch: '',
    }
  },
  computed: {
    ...mapGetters({
      items: "Content/getContents",
      paginationMeta: "Content/getPaginationMeta",
    }),
    isPost() {
      return this.contentType === 'post'
    }
  },
  watch: {
    items() {
      if (this.awaitingData) this.stopLoading()
    }
  },
  mounted() {
    this.getItems();
  },
  methods: {
    formatNumber,
    fetch(page) {
      // Content/getDashboardContents does not return its request promise,
      // so loading ends when the store list is replaced (see watch.items).
      this.listLoading = true
      this.awaitingData = true
      clearTimeout(this.loadingTimer)
      this.loadingTimer = setTimeout(this.stopLoading, 20000)
      this.$store.dispatch("Content/getDashboardContents", {type: this.contentType, page: page});
    },
    stopLoading() {
      this.awaitingData = false
      this.listLoading = false
      clearTimeout(this.loadingTimer)
      this.loadingTimer = null
    },
    changePage(page) {
      this.fetch(page)
    },
    getItems() {
      this.fetch(1)
    },
    setSearch(words) {
      this.activeSearch = words.searchWords
      this.$store.commit('Content/setFilters', {key: 'search', value: words.searchWords})
      this.getItems()
    },
    triggerSearch() {
      this.setSearch({searchWords: this.searchWords || ''});
    },
    clearSearch() {
      this.searchWords = ''
      this.setSearch({searchWords: ''})
    }
  },
  beforeDestroy() {
    clearTimeout(this.loadingTimer)
  },
  destroyed() {
    this.$store.commit('Content/setFilters', {key: 'search', value: ''})
  }
};
</script>

<style scoped>
.products-page {
  padding: 8px 4px 24px;
}

.products-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: linear-gradient(135deg, #1e1e1e 0%, #3a3a3a 55%, #eb3d60 140%);
  color: #fff;
  border-radius: 22px;
  padding: 24px 28px;
  margin-bottom: 22px;
}

.hero-kicker {
  opacity: 0.8;
  font-size: 13px;
}

.products-hero h1 {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 0;
}

.hero-side {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.hero-count {
  text-align: left;
}

.hero-count strong {
  display: block;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.1;
}

.hero-count span {
  font-size: 12px;
  opacity: 0.8;
}

.hero-badge {
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}

.content-list-page .products-filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 8px;
}

.content-list-page .products-more-btn {
  height: 34px;
  margin-top: 0;
}

.content-search-field {
  flex: 1 1 280px;
}

.content-search-btn {
  align-self: flex-end;
}

@media (max-width: 767px) {
  .products-page {
    padding: 4px 0 16px;
  }

  .products-hero {
    padding: 14px 14px;
    margin-bottom: 12px;
    border-radius: 16px;
  }

  .hero-badge {
    display: none;
  }

  .products-hero h1 {
    font-size: 22px;
  }

  .hero-count strong {
    font-size: 20px;
  }
}
</style>
